import React from 'react'
export default (props) => (
    <div>
        <section id="rules">
            <div className="anueContainer">
                <div className="titleBlock">
                    <h2 data-aos="flip-up"><i className="fas fa-bullhorn" style={{ marginRight: "10px" }}></i>活動辦法</h2>
                </div>
                <div className="anueContainer">
                    <div className="rulesText">
                        <div data-aos="fade-left">
                            <div className="tagBox">
                                <div className="tag">優惠辦法</div>
                            </div>
                            <ul>
                                <li><p>即日起，申購享單筆0手續費及定期定額終身0手續費。</p></li>
                                <li><p>本專案首次申購需同時進行單筆申購及定期定額扣款設定；每人不限定申購組數。</p></li>
                                <li><p>本專案提供台幣與美金扣款申購，最低申購金額說明如下：</p></li>
                                <ul style={{ listStyleType: "disc", marginLeft: "24px" }}>
                                    <li>單筆：最低申購金額為新台幣$10,000或美金$400；且單筆申購增額級距需以新台幣$1,000 或美金$50的倍數為申購金額。</li>
                                    <li>定期定額：最低申購金額為新台幣$5,000或美金$250；且定期定額申購增額級距需以新台幣$5,000或美金$250的倍數為申購金額。</li>
                                    <li>若組合中包含「台股基金」，則僅限使用台幣申購。</li>
                                </ul>
                                <div style={{ display: "flex", justifyContent: "center" }}>
                                    <table >
                                        <thead>
                                            <tr>
                                                <th style={{ width: "33%" }} >申購方式</th>
                                                <th style={{ width: "33%" }} colSpan="2">單筆</th>
                                                <th style={{ width: "33%" }} colSpan="2">定期定額</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td>幣別</td>
                                                <td>台幣</td>
                                                <td>美金</td>
                                                <td>台幣</td>
                                                <td style={{ width: "50px" }}>美金</td>
                                            </tr>
                                            <tr>
                                                <td>最低申購金額</td>
                                                <td>10,000</td>
                                                <td>400</td>
                                                <td>5,000</td>
                                                <td>250</td>
                                            </tr>
                                            <tr>
                                                <td>增額級距<sup>(註2)</sup></td>
                                                <td>1,000</td>
                                                <td>50</td>
                                                <td>5,000</td>
                                                <td>250</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>

                                <li>本專案定期定額扣款日每月1到31日皆可設定扣款，遇到例假日、非營業日或當月無該日期如（29、30、31），則順延至下一個營業日扣款(註3)；且需於指定扣款日前一營業日13:00前完成好日子專案申購，才能於當月指定扣款日生效，逾時則順延至次月生效。例如：好日子專案於5/5申購，當定期定額扣款日選擇為每月5日時，則首次扣款日為6/5。</li>
                                <li>本方案之優惠費率、活動期間或其他使用規範如有異動，本網將另行公告；鉅亨買基金保留隨時終止，或調整優惠活動之權利。</li>
                                <li>更多內容請參考【常見問題】專區。</li>
                            </ul>
                        </div>
                        <div data-aos="fade-left">
                            <div className="tagBox">
                                <div className="tag">注意事項</div>
                            </div>
                            <ul className="remark">
                                <li>申購優惠費率、活動期間或其他使用規範如有異動，將於鉅亨買基金官網另行公告；鉅亨買基金保留隨時終止，或調整優惠活動之權利。活動期間以本公司系統正確接收您的交易完成時間為準。</li>
                                <li>本專案定期定額的增額級距範例說明如下表</li>
                                <table>
                                    <thead>
                                        <tr>
                                            <th>申購方式</th>
                                            <th colSpan="2">單筆申購</th>
                                            <th colSpan="2">定期定額</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>幣別</td>
                                            <td>台幣</td>
                                            <td>美金</td>
                                            <td>台幣</td>
                                            <td>美金</td>
                                        </tr>
                                        <tr>
                                            <td>增額級距</td>
                                            <td>1,000</td>
                                            <td>50</td>
                                            <td>5,000</td>
                                            <td>250</td>
                                        </tr>
                                        <tr className="sec">
                                            <td>下單金額正確範例</td>
                                            <td>11,000</td>
                                            <td>450</td>
                                            <td>10,000</td>
                                            <td>750</td>
                                        </tr>
                                        <tr className="">
                                            <td>下單金額錯誤範例</td>
                                            <td>10,100</td>
                                            <td>410</td>
                                            <td>7,000</td>
                                            <td>550</td>
                                        </tr>
                                    </tbody>
                                </table>
                                <li>本專案基金「首次」設定定期定額可新增多組扣款日期，專案申購送出後即無法新增扣款日期。定期定額設定完成後，可進行變更扣款日期、金額，但不可做加減碼設定；好日子單一定期定額扣款日期之金額異動，依平台定期定額最低申購金額規範：台幣3,000/美元100，增額級距台幣1,000/美元50。</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
)